import React from "react";

import { Modal } from "reactstrap";

import { formatINR } from "utils/format";
import {
  PLAN_COMPARISON,
  PLAN_FOOTNOTES,
  PLAN_META,
  PLAN_ORDER,
  PLAN_TIP,
} from "utils/membershipPlans";

import "assets/css/flow.css";

function PlanComparisonModal({ isOpen, onClose, priceForPlan }) {
  const resolvePrice = (planKey) =>
    priceForPlan != null ? priceForPlan(planKey) : PLAN_META[planKey].price;

  return (
    <Modal
      isOpen={isOpen}
      size="lg"
      centered
      scrollable
      contentClassName="hm-modal"
      toggle={onClose}
    >
      <div className="hm-modal-head">
        <h5 className="hm-modal-title">Membership plan comparison</h5>
        <button aria-label="Close" className="hm-modal-x" type="button" onClick={onClose}>
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="hm-modal-body">
        <div className="hm-cmp-scroll">
          <table className="hm-cmp">
            <thead>
              <tr>
                <th>Benefit</th>
                {PLAN_ORDER.map((planKey) => (
                  <th key={planKey}>{planKey}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr className="hm-cmp-group">
                <th colSpan={PLAN_ORDER.length + 1}>Contribution per person</th>
              </tr>
              <tr>
                <th>Membership contribution</th>
                {PLAN_ORDER.map((planKey) => (
                  <td
                    className={
                      "hm-cmp-price" + (PLAN_META[planKey].featured ? " hm-cmp-hi" : "")
                    }
                    key={planKey}
                  >
                    &#x20B9;{formatINR(resolvePrice(planKey))}
                  </td>
                ))}
              </tr>
              {PLAN_COMPARISON.map((row) =>
                row.group != null ? (
                  <tr className="hm-cmp-group" key={row.group}>
                    <th colSpan={PLAN_ORDER.length + 1}>{row.group}</th>
                  </tr>
                ) : (
                  <tr key={row.label}>
                    <th>{row.label}</th>
                    {row.availability.map((on, i) => (
                      <td
                        className={PLAN_META[PLAN_ORDER[i]].featured ? "hm-cmp-hi" : ""}
                        key={PLAN_ORDER[i]}
                      >
                        {on ? (
                          <span className="hm-yes" aria-label="Included">✓</span>
                        ) : (
                          <span className="hm-no" aria-label="Not included">–</span>
                        )}
                      </td>
                    ))}
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
        <div className="hm-cmp-note">
          <span className="hm-cmp-note-label">Good to know</span>
          <ul className="hm-cmp-note-list">
            {PLAN_FOOTNOTES.map((note) => (
              <li key={note.marker}>
                <span className="hm-cmp-note-mark" aria-hidden={true}>
                  {note.marker}
                </span>
                <span>{note.text}</span>
              </li>
            ))}
          </ul>
          <p className="hm-cmp-tip">{PLAN_TIP}</p>
        </div>
      </div>
    </Modal>
  );
}

export default PlanComparisonModal;
